import React,{Component} from 'react';
import logo from '../../../images/logo-black.png';
import AuthHelper from '../../../libraries/auth-helper';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import NumberFormat from 'react-number-format';
import language from '../../../libraries/label-lang';
import {bindActionCreators} from 'redux';
import {RootActions} from '../../../shared/root-action';
import {connect} from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import templateId from "../../../libraries/lang-id";
import ReactToPrint from 'react-to-print';
import Button from '@material-ui/core/Button';
import _ from 'lodash';

SimpleReactValidator.addLocale('indo', templateId);

class Invoice extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            amount: '',
            amountOther: '',
            daily: '',
            fulfillment: '',

            totalPrices: 0,
            totalTax: 0,
            totalAll: 0,

            labels: [],
        };

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

    }

    componentDidMount(){

        document.title = 'Fresh Factory - Invoice';


    };

    handleChange (e, prop){

        this.setState({
            amount: '',
            [prop]: e.target.value

        })

    };

    handleGo  = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };


    render() {
        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        // console.log(this.state.labels)
        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories' >{text.label_history}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories/list' >List</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>Invoice</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>Invoice Transaksi</h2>
                <div className='row'>
                    <div className='col-lg-8'>
                        <PrintLabels data={this.state.labels} date={this.props.match.params.date} ref={el => (this.componentRef = el)} />
                        <ReactToPrint
                            trigger={() =>  <Button
                                variant='contained'
                                color='primary'
                                className='mt-3'
                            >Print</Button>}
                            content={() => this.componentRef}
                        />
                    </div>
                </div>

                <ToastContainer />
            </div>

        )

    }
}

class PrintLabels extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            labels: [],
            id: this.props.date,
            totalPrices: 0,
            totalTax: 0,
            totalAll: 0,
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

        Api.get('/expenses/invoices?month='+this.state.id).then(resp => {
            if (resp.data) {
                let total = 0;
                let tax = 0;

                _.forEach(resp.data.daily, function(v){
                    total += parseFloat(v.total_prices);
                    tax += parseFloat(v.tax);
                });
                _.forEach(resp.data.fulfillment, function(v){
                    total += parseFloat(v.total_prices);
                    tax += parseFloat(v.tax);
                });

                this.setState({
                        labels: resp.data,
                    totalPrices: Math.abs(total),
                    totalTax: Math.abs(tax),
                    totalAll: Math.abs(total+tax),
                    }
                );
            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });
    }

    render() {
        return (
            <div>
                <div className='card-white__dash'>
                    <table width="100%">
                        <tbody>
                        <tr>
                            <td width="70%">
                                <h2>Fresh Factory</h2>
                                <p>Jl. At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
                                    @info@freshfactory.com</p>
                            </td>
                            <td width="70%" className='text-right'>
                                <img src={logo} alt='logo' className='logo' />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <td width="45%">
                                            <small>Ditagihkan kepada</small>
                                            <p>{this.state.labels.profile && this.state.labels.profile.company_name}</p>
                                        </td>
                                        <td width="15%">
                                            <small>Status</small>
                                            <p>{this.state.labels.profile && this.state.labels.profile.status}</p>
                                        </td>
                                        <td width="15%">
                                            <small>Tanggal Invoice</small>
                                            <p>{this.state.labels.profile && this.state.labels.profile.invoices_date}</p>
                                        </td>
                                        <td width="15%">
                                            <small>Nomor Invoice</small>
                                            <p>FC1913KQYI19INV</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td><p className='text-blue mb-0'>BIAYA PENYIMPANAN</p></td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <table width="100%">
                                    <thead style={{background:'#f2f2f2'}}>
                                    <tr>
                                        <th style={{padding:10}}>Penyimpanan</th>
                                        <th style={{padding:10}}>Jumlah</th>
                                        <th style={{padding:10}}>Harga</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {
                                        this.state.labels.daily !== undefined &&
                                        this.state.labels.daily.length > 0 &&
                                        this.state.labels.daily.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td width="40%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>{row.storage} - {row.max_width} x {row.max_length}</p>
                                                    </td>
                                                    <td width="30%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>{row.total_product}</p>
                                                    </td>
                                                    <td width="30%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={Math.abs(row.total_prices)} displayType={'text'} renderText={value => value} /></p>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td><p className='text-blue mb-0'>BIAYA FULLFILMENT</p></td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <table width="100%">
                                    <thead style={{background:'#f2f2f2'}}>
                                    <tr>
                                        <th style={{padding:10}}>Penyimpanan</th>
                                        <th style={{padding:10}}>Jumlah</th>
                                        <th style={{padding:10}}>Harga</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {
                                        this.state.labels.fulfillment !== undefined &&
                                        this.state.labels.fulfillment.length > 0 &&
                                        this.state.labels.fulfillment.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td width="40%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>{row.storage} - {row.max_width} x {row.max_length}</p>
                                                    </td>
                                                    <td width="30%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>{row.total_product}</p>
                                                    </td>
                                                    <td width="30%" style={{paddingLeft:10,paddingRight:10}}>
                                                        <p className='mb-2'>Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} value={row.total_prices} displayType={'text'} renderText={value => value} /></p>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className='card-white__blue mt-3'>
                    <table width="100%">
                        <tbody>
                        <tr>
                            <td width="70%">
                                <p className='mb-0'>Total Biaya</p>
                            </td>
                            <td width="70%" className='text-right'>
                                <p className='mb-0'>
                                    Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.totalPrices} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="70%">
                                <p>PPN</p>
                            </td>
                            <td width="70%" className='text-right'>
                                <p>
                                    Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.totalPrices} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="70%">
                                <p className='mb-0'>Total Pembayaran</p>
                            </td>
                            <td width="70%" className='text-right'>
                                <p className='mb-0'>
                                    Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.totalPrices} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                </p>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>


        )
    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Invoice));